import { render, staticRenderFns } from "./Features.vue?vue&type=template&id=c7b6f8e8"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {SectionHeader: require('/opt/build/repo/components/section/Header.vue').default,ShopFeaturesTabs: require('/opt/build/repo/components/shop/FeaturesTabs.vue').default})
